export default __webpack_public_path__ + "static/media/add-to-playlist-pink.af5e6837.svg";